import { DEFAULT_LOCALE_CODE, VALID_LOCALES } from '../constants';
var getBrowserLocale = function () {
    return VALID_LOCALES.includes(navigator === null || navigator === void 0 ? void 0 : navigator.language) ? navigator.language : DEFAULT_LOCALE_CODE;
};
export default getBrowserLocale;
